import React from "react";
//import Service from "../../../Service/Accounts/AcountTransactions.service"
import Service from "Service/Accounts/JournalTypes.service"
//import Service from "../../Service/Item-master/itemMaster.service"
import Table from "../../MUI_components/Table/table";
import Title from "../../Card/title"
import AddEntryAccount from "./AddJounralTypeAccount";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";

const JournalTypes = () => {
  const EntryTransactionTableHeadCells = [
    {
      id: (row) => row["code"],
      numeric: false,
      disablePadding: false,
      label: COLUMNS_NAME.ACC_TRANSACTION_CODE,
    },

    
     {
     id: (row) => row["name"],
      numeric: false,
       disablePadding: false,
       label:  COLUMNS_NAME.DESCRIPTION,
     },

    {
      id: (row) => row["entryTypeFrom"] == 0 ? "DEBIT" : "CREDIT",
      numeric: false,
      disablePadding: false,
      label: COLUMNS_NAME.ENTRY_TYPE,
    },
    
    // {
    //   id: (row) => (row["isDebit"] == 0 ? "Debit" : "Credit"),
    //   numeric: false,
    //   disablePadding: false,
    //   label: COLUMNS_NAME.CREDIT_OR_DEBIT,
    // },

  ];

  return (
    <>
      <Title>Journal Type Account</Title>
      <Table
        title="Journal Type Account"
        headCells={EntryTransactionTableHeadCells}
        AddComponent={AddEntryAccount}
        service={Service}
        withoutLocationFilter
        //editable
        searchable
      />
    </>
  );
};

export default JournalTypes;
